export enum Rpc {
  SendEditorValue = 'SEND_EDITOR_VALUE',
  CloseEditor = 'CLOSE_EDITOR',
}
